
export const textAlign = {
  name: 'text-align'
}

export const textDecoration = {
  name: 'text-decoration'
}

export const textTransform = {
  name: 'text-transform'
}

export const textShadow = {
  name: 'text-shadow'
}

export const textOverflow = {
  name: 'text-overflow'
}

export const color = {
  name: 'color'
}

export const font = {
  name: 'font'
}

export const fontFamily = {
  name: 'font-family'
}

export const fontSize = {
  name: 'font-size'
}

export const fontStyle = {
  name: 'font-style'
}

export const fontVariant = {
  name: 'font-variant'
}

export const fontWeight = {
  name: 'font-weight',
  unit: ''
}

export const lineHeight = {
  name: 'line-height',
  unit: ''
}

export const wordBreak = {
  name: 'word-break'
}

export const wordWrap = {
  name: 'word-wrap'
}

export const whiteSpace = {
  name: 'white-space'
}

export const letterSpacing = {
  name: 'letter-spacing'
}